export function getEpParam() {
  const urlParams = new URLSearchParams(window.location.search);
  const ep = urlParams.get("ep");

  return ep?.replace(/\/$/, "");
}

export function isPreviewMode(ep?: string): boolean {
  const referrer = document.referrer?.replace(/\/$/, "");

  return Boolean(referrer && ep && referrer === ep);
}

export function getRelativePreviewUrl(url: string) {
  const uiPos = url.indexOf("ui");
  if (uiPos !== -1) {
    return url.substring(uiPos);
  }

  return url;
}

export function getRelativePreviewUrls(urls: Record<string, string>): Record<string, string> {
  return Object.fromEntries(Object.entries(urls).map(([id, url]) => [id, getRelativePreviewUrl(url)]));
}
